<template>
  <div id="restaurant-selection-screen" class="w-full h-full flex items-center justify-center p-4">
    <div class="setup-card flex flex-col">
      <div class="text-center mb-6">
        <div class="text-3xl font-extrabold mb-2" style="color: var(--ods-accent-ink)">MealWave</div>
        <h1 class="text-xl">اختر المطعم</h1>
        <p class="text-sm ods-muted">Select your restaurant to continue</p>
      </div>
      
      <div class="mb-4">
        <input 
          type="text" 
          id="restaurant-search" 
          v-model="searchQuery"
          placeholder="البحث عن المطعم..." 
          class="ods-input"
        >
      </div>
      
      <div id="restaurant-list" class="max-h-80 overflow-y-auto mb-6">
        <div v-if="loading" class="text-center ods-muted">
          <div class="animate-spin w-8 h-8 border-t-2 rounded-full mx-auto mb-2" style="border-color: var(--ods-accent)"></div>
          <p>Loading restaurants...</p>
        </div>
        <div v-else-if="filteredRestaurants.length === 0" class="text-center ods-muted">
          <i class="fas fa-store-slash text-3xl mb-2"></i>
          <p>{{ searchQuery ? `No restaurants found matching "${searchQuery}"` : 'No restaurants found' }}</p>
        </div>
        <div 
          v-else
          v-for="(restaurant, id) in filteredRestaurants" 
          :key="id"
          @click="selectRestaurant(id)"
          class="restaurant-item p-3 mb-2 cursor-pointer"
        >
          <div class="font-bold">{{ restaurant.info?.name || id }}</div>
          <div class="text-sm ods-muted">{{ id }}</div>
        </div>
      </div>
      
      <div class="text-center ods-muted text-sm">
        <p>لم تجد مطعمك؟</p>
        <button 
          @click="enterRestaurantIdManually"
          class="hover:underline mt-1 font-bold" style="color: var(--ods-accent-ink)"
        >
          Enter Restaurant ID manually
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'RestaurantSelectionView',
  data() {
    return {
      searchQuery: '',
      loading: true
    };
  },
  computed: {
    ...mapState(['restaurants']),
    filteredRestaurants() {
      if (!this.searchQuery || !this.restaurants) return this.restaurants;
      
      const query = this.searchQuery.toLowerCase();
      return Object.entries(this.restaurants)
        .filter(([id, restaurant]) => {
          const name = restaurant.info?.name?.toLowerCase() || id.toLowerCase();
          return name.includes(query);
        })
        .reduce((acc, [id, restaurant]) => {
          acc[id] = restaurant;
          return acc;
        }, {});
    }
  },
  mounted() {
    this.loadRestaurants();
  },
  methods: {
    ...mapActions(['loadRestaurants', 'setSelectedRestaurant']),
    selectRestaurant(restaurantId) {
      const restaurant = this.restaurants[restaurantId];
      const restaurantName = restaurant.info?.name || restaurantId;
      
      this.setSelectedRestaurant({ id: restaurantId, name: restaurantName });
      this.$router.push('/station-selection');
    },
    enterRestaurantIdManually() {
      const restaurantId = prompt("Please enter the restaurant ID:");
      if (restaurantId && restaurantId.trim()) {
        this.selectRestaurant(restaurantId.trim());
      }
    },
    async loadRestaurants() {
      this.loading = true;
      try {
        await this.$store.dispatch('loadRestaurants');
      } catch (error) {
        console.error('Error loading restaurants:', error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.setup-card { background: var(--ods-surface); border-radius: var(--ods-radius-lg); padding: 2rem; width: 100%; max-width: 520px; box-shadow: var(--ods-shadow-lg); border: 1px solid var(--ods-line); color: var(--ods-ink); }
.ods-muted { color: var(--ods-ink-3); }
.ods-input { width: 100%; height: 48px; padding: 0 14px; background: var(--ods-surface-2); border: 1px solid var(--ods-line-2); border-radius: var(--ods-radius); color: var(--ods-ink); font-size: 15px; font-weight: 600; }
.ods-input:focus { outline: none; border-color: var(--ods-accent); box-shadow: 0 0 0 3px var(--ods-accent-tint); }
.restaurant-item { background: var(--ods-surface-2); border: 1px solid var(--ods-line); border-radius: var(--ods-radius); transition: border-color .15s, background .15s; }
.restaurant-item:hover { border-color: var(--ods-accent); background: var(--ods-accent-tint); }
</style>